import Vue from 'vue'

import ErrorsContainer from '~/components/global/ErrorsContainer.vue'
Vue.component('ErrorsContainer', ErrorsContainer)
